export class AssistanceCenter {
    public selectedTab: string;
    public selectedTabName: string;
}
